import { render, staticRenderFns } from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=template&id=3a39caf0&scoped=true"
import script from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=3a39caf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39caf0",
  null
  
)

export default component.exports